import { FC } from 'react';
import { CatToastGroup } from '@blocks-react/components/ToastGroup';
import { RequestSerivceToastGroupProps } from '../types';
import { RequestSerivceToast } from '../request-serivce-toast/RequestSerivceToast';

export const RequestSerivceToastGroup: FC<RequestSerivceToastGroupProps> = ({
  toastGroupProps, toastProps
}) => {
  return (
    <CatToastGroup
      {...toastGroupProps}
    >
      <RequestSerivceToast
        {...toastProps}
      />
    </CatToastGroup>
  );
};
